<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        BGV Verification Report
    </div>
    <div class="card-body">
        <form class="g-3" name="ReportForm" #ReportForm="ngForm" novalidate>
            <div class="row my-1">
                <div class="col-md-4 px-1">
                    <label for="FromDateObj" class="form-font-label"> From Date<span
                            class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label for="ToDateObj" class="form-font-label">To Date<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label for="IsDraft" class="form-font-label">Draft Employee<span
                            class="text-danger">*</span></label>
                    <select class="form-select" aria-label="IsDraft" placeholder="Draft Employee" title="DraftEmployee"
                        name="DraftEmployee" data-live-search="true" [(ngModel)]="Filter.IsDraft"
                        #HalfDaySession="ngModel" required>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                    </select>
                </div>
            </div>
            <div class="row my-1">
                <div class="col-md-4 px-1">
                    <label class="Label">Branch</label>
                    <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="All Branch" [closeOnSelect]="false" [(ngModel)]="Filter.BranchIdsObj"
                        [virtualScroll]="true" (change)="DropdownChange('Branch')"  name="branchs">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Branch')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.BranchName">{{item.BranchName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.BranchName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-8 px-1">
                    <label class="Label">Site</label>
                    <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                        placeholder="All Site" [closeOnSelect]="false" [(ngModel)]="Filter.SiteIdsObj"
                        [virtualScroll]="true" (change)="DropdownChange('Site')" name="sites">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Site')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.SiteName">{{item.SiteName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row my-1">
                <div class="col-md-4 px-1">
                    <label class="Label">Status</label>
                    <ng-select [items]="BgvStatus" [multiple]="true" bindLabel="Status" bindValue="Status"
                        placeholder="All Status" [closeOnSelect]="false" [(ngModel)]="Filter.BGVStatusObj"
                        [virtualScroll]="true"  name="Status">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'BGVStatus')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span><span style="width: 15px;height: 15px; display: inline-flex;"
                                    [ngStyle]="{ 'background':item.ColourCode}"></span>{{item.Status}}</span>

                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.Status}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-4 px-1">
                    <label class="Label">Verification Status</label>
                    <ng-select [items]="BgvStatus" [multiple]="true" bindLabel="Status" bindValue="Status"
                        placeholder="All Final Status" [closeOnSelect]="false"
                        [(ngModel)]="Filter.FinalVerificationStatusObj" [virtualScroll]="true" name="BgvStatus">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'FinalBGVStatus')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span><span style="width: 15px;height: 15px; display: inline-flex;"
                                    [ngStyle]="{ 'background':item.ColourCode}"></span>{{item.Status}}</span>

                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.Status}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col px-1">
                    <label class="Label" for="empcode">Employee Code</label>
                    <input name="empcode" type="text" placeholder="Enter Employee Code" [(ngModel)]="Filter.EmpCodes"
                        class="form-control" />
                </div>
                <div class="col-auto px-1 align-content-end">
                    <button (click)="ESS_EmpBGVVerificationReportDetails()" type="button"
                        *ngIf="this.common.PageRight.IsPrint" class="btn btn-primary" [disabled]="isDisabled">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        {{!isDisabled? 'Excel':'Loading...'}}</button>
                </div>
            </div>
        </form>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <!-- <button (click)="ESS_EmpBGVVerificationReportDetails()" type="button" *ngIf="this.common.PageRight.IsPrint"
                class="btn btn-primary btn-sm" [disabled]="isDisabled"><i class="bi bi-file-earmark-arrow-down"
                    *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled? 'Excel':'Loading...'}}</button> -->

            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>
</div>